<mat-card>
    <mat-form-field class="full-width">
        <mat-label>Message (optional)</mat-label>
        <input
            matInput
            maxlength="200"
            placeholder="Message (optional)"
            formControlName="message"
            (keyup.enter)="submitForm()"
            qa="gift-card-message"
        />
    </mat-form-field>
</mat-card>
